import { render } from "./BannerPasseios.vue?vue&type=template&id=006dd041&lang=pug"
import script from "./BannerPasseios.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerPasseios.vue?vue&type=script&setup=true&lang=js"

import "./BannerPasseios.vue?vue&type=style&index=0&id=006dd041&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__